import {type App } from "vue";
import 'vuetify/styles'
import { createVuetify as _createVuetify, type ThemeDefinition } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import "emoji-mart-vue-fast/css/emoji-mart.css";
import { VFileUpload,VFileUploadItem } from 'vuetify/labs/VFileUpload'
import 'vue3-toastify/dist/index.css';

export {createVuetify}
function createVuetify() {
  const ChatCustomTheme: ThemeDefinition = {
    dark: false,
    colors: {
      // primary:"#D23F00",
      // "primary-darken-1": "#C24008",

      // secondary:  "#0A77D6",
      // "secondary-darken-1": "#0A77D6",
      // "secondary-lighten-1": "#E5F2FF",

      // tertiary: "#0e4678",
      // "tertiary-lighten-1": "#E5F2FF",
      // "tertiary-lighten-2": "#E9F0F7",
      // "tertiary-lighten-3": "#FBFDFF",
      // "tertiary-lighten-4": "#F0F6FC",

      orange: "#D23F00",
      "orange-lighten-1": "#FEF6F2",

      grey: "#4C6177",
      "grey-lighten-1": "#94A9C3",
      "grey-lighten-2": "#C4D2E4",
      "grey-lighten-3": "#F4F6F8",

      success: "#017517",
      "success-lighten-1": "#EDFAF0",
      "success-lighten-2": "#D9F2DE",
      "success-lighten-3": "#F9FFFA",

      purple: "#3A0C75",
      "purple-lighten-1": "#F8F3FF",

      error: "#CA140B",
      "error-lighten-1": "#FFF4F4",
      "error-lighten-2": "#F7CDCD",

      info: "#0055B6",
      "info-lighten-1": "#DDE9FA",
      "info-lighten-2": "#F1F7FF",

      note: "#966C00",
      "note-lighten-1": "#FDF1D5",
      "note-lighten-2": "#FFF9EB",

      warning: "#75492A",
      "warning-lighten-1": "#F8DFBB",
      "warning-lighten-2": "#FFF0DA",

      disable: "#F2F6FA",
      link: "#170dfd",
      white: "#fff",
      black: "#142535",
/* Custome recommended theme for AIBOT */
// black: "#000000",
//       grey: "#7f7f7f",
//       "grey-lighten-1": "#e0e0e0",
//       "grey-lighten-2": "#f5f5f5",
      /* Custome recommended theme for AIBOT */
    },

  };
    return _createVuetify({
        components:{
          ...components,
          VFileUpload,
          VFileUploadItem
        },
        directives,
        theme: {
            defaultTheme: "ChatCustomTheme",
            themes: {
              ChatCustomTheme,
            },
          },
      });
}